<template>
    <div class="pagination">
        <el-pagination background layout="prev, pager, next"
                       :total="pageInfo.total" :page-size="pageInfo.pageSize"
                       @current-change="handlePageChange"/>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                pageModel: this.model
            };
        },
        props: {
            model: { type: Object, default: '' }
        },
        watch: {
            model(val) {
                this.pageModel = val;
            }
        },
        computed: {
            pageInfo() {
                if (this.pageModel.getPageInfo) {
                    return this.pageModel.getPageInfo();
                }
                return {};
            }
        },
        methods: {
            handlePageChange(page) {
                const me = this;
                this.pageModel.turnToPage(page);
                const pageInfo = this.pageModel.getPageInfo();
                let p = { businessId: pageInfo.businessId, page: pageInfo.page, pageSize: pageInfo.pageSize };
                p = Object.assign({}, this.pageModel.params, p);
                this.$store.state.app.$http.get(pageInfo.url, { params: p, loading: true }).then((response) => {
                    me.pageModel.set(response.data);
                });
            }
        }
    };
</script>
